const en = {
  product_id: 'Product ID',
  product_name: 'Product name',
  product_description: 'Product description',
  description: 'Description',
  short_description: 'Short description',
  countries: 'Countries',
  product_type: 'Product type',
  account: 'Account',
  bar_code: 'Code (barcode)',
  quantity: 'Quantity',
  enabled: 'Enabled',
  instant_buy: 'Instant buy',
  requires_billing_address: 'Requires billing address',
  requires_shipping_address: 'Requires shipping address',
  requires_contact_mobile: 'Requires contact mobile',
  requires_contact_email: 'Requires contact email',
  metadata: 'Metadata',
  created: 'Date created',
  updated: 'Date updated',
  images: 'Images',
  prices: 'Prices',
  categories: 'Categories',
  order_id: 'Order ID',
  user_id: 'User ID',
  status: 'Status',
  currency: 'Currency',
  placed: 'Date placed',
  parent_category: 'Parent category',
  category_name: 'Category name',
  pricing_quantity_and_variants: 'Pricing, quantity and variants',
  no_orders:
    'No orders have been placed yet. Orders will appear here once they have been made.',
  order_info: 'Order info',
  payments: 'Payments',
  refunds: 'Refunds',
  product_items: 'Product Items',
  action: 'Action',
  start: 'Start',
  total_refundable_amount: 'Total refundable amount',
  select_items_to_refund: 'Select items to refund',
  refund_reason_required: 'Refund reason is required',
  refund_quantity_required: 'Refund quantity is required',
  select_at_least_one_item: 'Please select at least one item to refund',
  reason_for_refund: 'Reason for refund',
  quantity_to_refund: 'Quantity to refund',
  select_item_for_refund: 'Select this item for refund',
};

export default en;
